import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

export const getCountries = (instance: AxiosInstance) => async (): Promise<Country[]> => {
  const { data } = await instance.get<Country[]>('/metadata/countries');

  return data;
};

export const getStates = (instance: AxiosInstance) => async (state: string): Promise<CountryState[]> => {
  const { data } = await instance.get<CountryState[]>(`/metadata/countrysubdivisions?country=${state}`);

  return data;
};

const handlers = {
  getCountries,
  getStates,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createCountriesApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createCountriesApi;
